import global from './global';
import organizationWeekPlannerLocales from './organizationWeekPlannerLocales';
import organizationPlannerJobDetailsLocales from './organizationPlannerJobDetailsLocales';
import organisationIntegrationSettingsLocales from './organisationIntegrationSettingsLocales';
import freelancerAvailableJobsLocales from './freelancerAvailableJobsLocales';
import freelancerAvailabilityLocales from './freelancerAvailabilityLocales';
import freelancerSignUpLocales from './freelancerSignUpLocales';
import freelancerLoginLocales from './freelancerLoginLocales';
import freelancerForgotPasswordLocales from './freelancerForgotPasswordLocales';
import freelancerResetPasswordLocales from './freelancerResetPasswordLocales';
import freelancerLandingLocales from './freelancerLandingLocales';
import freelancerFillInformationPageLocales from './freelancerFillInformationPageLocales';
import freelancerWelcomePageLocales from './freelancerWelcomePageLocales';
import freelancerPersonalInformationPageLocales from './freelancerPersonalInformationPageLocales';
import freelancerDiplomasYearSelectionPageLocales from './freelancerDiplomasYearSelectionPageLocales';
import freelancerDiplomasInformationPageLocales from './freelancerDiplomasInformationPageLocales';
import freelancerAddDiplomasDocumentPageLocales from './freelancerAddDiplomasDocumentPageLocales';
import freelancerCertificationInformationPageLocales from './freelancerCertificationInformationPageLocales';
import freelancerAddCertificationDocumentPageLocales from './freelancerAddCertificationDocumentPageLocales';
import freelancerCompetenciesInformationPageLocales from './freelancerCompetenciesInformationPageLocales';
import freelancerPersonRegisterInformationPageLocales from './freelancerPersonRegisterInformationPageLocales';
import freelancerDocumentsInformationPageLocales from './freelancerDocumentsInformationPageLocales';
import freelancerInsuranceInformationPageLocales from './freelancerInsuranceInformationPageLocales';
import freelancerKVKInformationPageLocales from './freelancerKVKInformationPageLocales';
import freelancerSubmitApplicationPageLocales from './freelancerSubmitApplicationPageLocales';
import organisationPeriodJobsLocales from './organisationPeriodJobsLocales';

export default {
  freelancerAddCertificationDocumentPageLocales,
  freelancerAddDiplomasDocumentPageLocales,
  freelancerAvailabilityLocales,
  freelancerAvailableJobsLocales,
  freelancerCertificationInformationPageLocales,
  freelancerCompetenciesInformationPageLocales,
  freelancerDiplomasInformationPageLocales,
  freelancerDiplomasYearSelectionPageLocales,
  freelancerDocumentsInformationPageLocales,
  freelancerFillInformationPageLocales,
  freelancerForgotPasswordLocales,
  freelancerInsuranceInformationPageLocales,
  freelancerKVKInformationPageLocales,
  freelancerLandingLocales,
  freelancerLoginLocales,
  freelancerPersonalInformationPageLocales,
  freelancerPersonRegisterInformationPageLocales,
  freelancerResetPasswordLocales,
  freelancerSignUpLocales,
  freelancerSubmitApplicationPageLocales,
  freelancerWelcomePageLocales,
  global,
  organisationIntegrationSettingsLocales,
  organisationPeriodJobsLocales,
  organizationPlannerJobDetailsLocales,
  organizationWeekPlannerLocales,
};
